<template>
    <div id="site-list-component">
        <AppBreadCrumb :paths="[{ title: $t('message.sites') }]" :select="true">
            <a-button class="ml-2 actionButtonBreadcrumb" @click="$router.push(`/sites`)"> Eski UI</a-button>
        </AppBreadCrumb>
        <div class="route-page-content breadcrumb-content">
            <SidebarChild :items="menuItems" :focusActive="true" @selected="handleSidebarSelection" />
            <div class="position-relative pt-3 content-wrapper">
                <div class="toolbar-container">
                    <SiteFilterToolbar v-model="filters" ref="filterToolbar" />
                    <div class="actions">
                        <SupsisButton @click="updateView" warning> ❗ Update View️</SupsisButton>
                        <SupsisButton @click="refreshData" primary>
                            <small class="keyboard-shortcut">⌥R</small>
                            {{ $t("message.refresh") }}
                        </SupsisButton>
                        <SupsisButton @click="openColumnSettings" primary>
                            <small class="keyboard-shortcut">⌥C</small>
                            Tablo Ayarları
                        </SupsisButton>

                        <SupsisButton @click="downloadAsExcel" primary> Download Excel</SupsisButton>
                    </div>
                </div>

                <div v-if="checkboxOption.selectedRowKeys.length > 0" class="bulk-action-bar">
                    <a-button @click="bulkDelete" type="danger">Toplu Sil</a-button>
                </div>
                <div v-if="bulkDeleteProgress" class="progress-bar">
                    <a-progress :percent="bulkDeleteProgress" />
                </div>
                <div class="table-wrapper">
                    <supsis-table
                        :columns="columns()"
                        :rows="sites"
                        :bottom-pagination="true"
                        :pagination-cursor="paginationCursor"
                        @cursor-changed="onCursorChanged"
                        :options="{ eventCustomOption, checkboxOption }"
                        id="site-list-table"
                        empty-text="Gösterilecek veri yok."
                    >
                        
                    </supsis-table>
                </div>
            </div>
        </div>
        <Modal2
            v-if="isColumnSettingsModalVisible"
            :title="$t('ticket.columnSettings')"
            :showFooter="false"
            @cancel="closeColumnSettings"
            id="site-list-column-settings"
        >
            <SiteColumnSelector
                :selected-columns="selectedColumns"
                :all-columns="allColumns"
                @save="saveColumnSettings"
                @cancel="closeColumnSettings"
            />
        </Modal2>
    </div>
</template>

<script>
import Vue from "vue";
import SupsisTable from "../../../components/SupsisTable.vue";
import SiteFilterToolbar from "./SiteFilterToolbar.vue";
import SupsisButton from "../../Pages/Settings/components/SupsisButton.vue";
import { lookupSitesV2 } from "../../../api/site";
import SidebarChild from "../../../components/Sidebar/SidebarChild.vue";
import moment from "moment";
import SiteColumnSelector from "./SiteColumnSelector.vue";
import Modal2 from "../../../components/common/Modal2.vue";
import HoverMenuCell from "../../../components/common/HoverMenuCell.vue";
import _ from "lodash";
import ActionEdit from "../../../components/svg/ActionEdit.vue";
import ActionDelete from "../../../components/svg/ActionDelete.vue";
import AppBreadCrumb from "../../../components/common/AppBreadCrumb.vue";
import { VeLoading } from "vue-easytable";
import request from "../../../utils/request";
import { mapActions, mapState } from "vuex";
export default Vue.extend({
    name: "SiteList",
    components: {
        AppBreadCrumb,
        SupsisTable,
        SiteFilterToolbar,
        SupsisButton,
        SidebarChild,
        SiteColumnSelector,
        Modal2,
        HoverMenuCell,
        ActionEdit,
        ActionDelete,
    },
    props: {
        defaultFilterTemplate: {
            type: String,
            default: "all-sites",
        },
    },
    data() {
        return {
            loadingInstance: null,
            filters: [],
            sites: [],
            total: 0,
            paginationCursor: {
                total: 0,
                page: 1,
                perPage: 10,
            },
            checkboxOption: {
                selectedRowKeys: [],
                selectedRowChange: ({ selectedRowKeys }) => {
                    this.checkboxOption.selectedRowKeys = selectedRowKeys;
                },
                selectedAllChange: ({ selectedRowKeys }) => {
                    this.checkboxOption.selectedRowKeys = selectedRowKeys;
                },
            },
            loading: false,
            eventCustomOption: {
                bodyCellEvents: () => {
                    return {
                        dblclick: (event) => {
                            const columnIndex = event.target.cellIndex;
                            const column = this.allColumns.find((col) => col.key === this.columns()[columnIndex].key);
                            if (!column) return;
                            if (column.copyDisabled) {
                                return;
                            }
                            let text = event.target.innerText;
                            let textArea = document.createElement("textarea");
                            textArea.value = text;
                            document.body.appendChild(textArea);
                            textArea.select();
                            document.execCommand("copy");
                            document.body.removeChild(textArea);
                            this.$message.success({
                                content: this.$t("message.copiedClipboard"),
                                duration: 2,
                                key: "saved",
                            });
                        },
                    };
                },
            },
            menuItems: [
                {
                    enabled: true,
                    key: "all-sites",
                    label: "Tüm Siteler",
                    icon: {
                        type: "material-icons",
                        name: "web",
                    },
                },
                {
                    enabled: true,
                    key: "suspended-sites",
                    label: "Askıya Alınmış Siteler",
                    icon: {
                        type: "material-icons",
                        name: "pause_circle_filled",
                    },
                },
                {
                    enabled: true,
                    key: "paid-at-least-once",
                    label: "En Az 1 Kere Ödeme Yapanlar",
                    icon: {
                        type: "material-icons",
                        name: "payment",
                    },
                },
                {
                    enabled: true,
                    key: "no-payment-last-month",
                    label: "1 Aydan Fazladır Ödeme Yapmayanlar",
                    icon: {
                        type: "material-icons",
                        name: "money_off",
                    },
                },
                {
                    enabled: true,
                    key: "whatsapp-buyers",
                    label: "WhatsApp Satın Alanlar",
                    icon: {
                        type: "material-icons",
                        name: "chat",
                    },
                },
                {
                    enabled: true,
                    key: "chatbot-buyers",
                    label: "Chatbot Satın Alanlar",
                    icon: {
                        type: "material-icons",
                        name: "android",
                    },
                },
                {
                    enabled: true,
                    key: "yearly-subscribers",
                    label: "Yıllık Satın Alma Yapanlar",
                    icon: {
                        type: "material-icons",
                        name: "date_range",
                    },
                },
            ],
            selectedColumns: [],
            isColumnSettingsModalVisible: false,
            allColumns: [
                {
                    group: "siteFields",
                    title: "Site Adresi",
                    key: "siteAddress",
                    renderBodyCell: ({ row }) => this.renderHoverMenuCell(row, "siteAddress", row.siteAddress),
                },
                {
                    group: "siteFields",
                    title: "Takma Ad",
                    key: "alias",
                    renderBodyCell: ({ row }) => this.renderHoverMenuCell(row, "alias", row.alias),
                },
                {
                    group: "siteFields",
                    title: "Etkin",
                    key: "enable",
                    renderBodyCell: ({ row }) => this.renderEnableChip(row),
                },
                {
                    group: "siteFields",
                    title: "Askıya Alınmış",
                    key: "suspend",
                    renderBodyCell: ({ row }) => this.renderSuspendChip(row),
                },
                {
                    group: "siteFields",
                    title: "Kök Kullanıcı Adı",
                    key: "rootUserName",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "rootUserName"),
                },
                {
                    group: "siteFields",
                    title: "Kök Kullanıcı E-postası",
                    key: "rootUserEmail",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "rootUserEmail"),
                },
                {
                    group: "siteFields",
                    title: "Telefon",
                    key: "phone",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "phone"),
                },
                {
                    group: "siteFields",
                    title: "Ortak Adı",
                    key: "partner.name",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "partner.name"),
                },
                {
                    group: "siteFields",
                    title: "Ödeme Yöntemi",
                    key: "paymentMethod",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "paymentMethod"),
                },
                // Fatura Alanları
                {
                    group: "invoiceFields",
                    title: "Oluşturulan Fatura Sayısı",
                    key: "invoiceInfo.createdCount",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "invoiceInfo.createdCount"),
                },
                {
                    group: "invoiceFields",
                    title: "Toplam Tutar",
                    key: "invoiceInfo.totalAmount",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "invoiceInfo.totalAmount"),
                },
                {
                    group: "invoiceFields",
                    title: "Son Fatura Tarihi",
                    key: "invoiceInfo.lastInvoiceDate",
                    renderBodyCell: ({ row }) => this.renderDateContent(row, "invoiceInfo.lastInvoiceDate"),
                },
                {
                    group: "invoiceFields",
                    title: "İlk Fatura Tarihi",
                    key: "invoiceInfo.firstInvoiceDate",
                    renderBodyCell: ({ row }) => this.renderDateContent(row, "invoiceInfo.firstInvoiceDate"),
                },
                {
                    group: "invoiceFields",
                    title: "Ödenen Fatura Sayısı",
                    key: "invoiceInfo.paidCount",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "invoiceInfo.paidCount"),
                },
                {
                    group: "invoiceFields",
                    title: "Ödenen Tutar",
                    key: "invoiceInfo.paidAmount",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "invoiceInfo.paidAmount"),
                },
                {
                    group: "invoiceFields",
                    title: "Ödenmemiş Fatura Sayısı",
                    key: "invoiceInfo.unpaidCount",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "invoiceInfo.unpaidCount"),
                },
                {
                    group: "invoiceFields",
                    title: "Ödenmemiş Tutar",
                    key: "invoiceInfo.unpaidAmount",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "invoiceInfo.unpaidAmount"),
                },
                {
                    group: "invoiceFields",
                    title: "Son Ödeme Tarihi",
                    key: "invoiceInfo.lastPaymentDate",
                    renderBodyCell: ({ row }) => this.renderDateContent(row, "invoiceInfo.lastPaymentDate"),
                },
                {
                    group: "invoiceFields",
                    title: "İlk Ödeme Tarihi",
                    key: "invoiceInfo.firstPaymentDate",
                    renderBodyCell: ({ row }) => this.renderDateContent(row, "invoiceInfo.firstPaymentDate"),
                },
                {
                    group: "invoiceFields",
                    title: "Son Ödemeden Bu Yana Geçen Gün",
                    key: "invoiceInfo.tookDaysFromLastPayment",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "invoiceInfo.tookDaysFromLastPayment"),
                },
                // Plan Alanları
                {
                    group: "planFields",
                    title: "Aylık Plan Sayısı",
                    key: "planInfo.monthlyPlanCount",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "planInfo.monthlyPlanCount"),
                },
                {
                    group: "planFields",
                    title: "3 Aylık Plan Sayısı",
                    key: "planInfo.monthly3PlanCount",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "planInfo.monthly3PlanCount"),
                },
                {
                    group: "planFields",
                    title: "6 Aylık Plan Sayısı",
                    key: "planInfo.monthly6PlanCount",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "planInfo.monthly6PlanCount"),
                },
                {
                    group: "planFields",
                    title: "Yıllık Plan Sayısı",
                    key: "planInfo.yearlyPlanCount",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "planInfo.yearlyPlanCount"),
                },
                {
                    group: "planFields",
                    title: "Süresiz Plan Sayısı",
                    key: "planInfo.foreverPlanCount",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "planInfo.foreverPlanCount"),
                },
                {
                    group: "planFields",
                    title: "WhatsApp Plan Sayısı",
                    key: "planInfo.whatsappPlanCount",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "planInfo.whatsappPlanCount"),
                },
                {
                    group: "planFields",
                    title: "WhatsApp Business Plan Sayısı",
                    key: "planInfo.whatsappBusinessPlanCount",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "planInfo.whatsappBusinessPlanCount"),
                },
                {
                    group: "planFields",
                    title: "Supsis Plan Sayısı",
                    key: "planInfo.supsisPlanCount",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "planInfo.supsisPlanCount"),
                },
                {
                    group: "planFields",
                    title: "Chatbot Plan Sayısı",
                    key: "planInfo.chatbotPlanCount",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "planInfo.chatbotPlanCount"),
                },
                {
                    group: "planFields",
                    title: "Instagram Plan Sayısı",
                    key: "planInfo.instagramPlanCount",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "planInfo.instagramPlanCount"),
                },
                {
                    group: "planFields",
                    title: "Messenger Plan Sayısı",
                    key: "planInfo.messengerPlanCount",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "planInfo.messengerPlanCount"),
                },
                {
                    group: "planFields",
                    title: "Ek Paket Plan Sayısı",
                    key: "planInfo.extraPackagePlanCount",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "planInfo.extraPackagePlanCount"),
                },
                {
                    group: "planFields",
                    title: "Özel Plan Sayısı",
                    key: "planInfo.customPlanCount",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "planInfo.customPlanCount"),
                },
                {
                    group: "planFields",
                    title: "Özellik Plan Sayısı",
                    key: "planInfo.featurePlanCount",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "planInfo.featurePlanCount"),
                },
                {
                    group: "planFields",
                    title: "WhatsApp Planı Var Mı",
                    key: "planInfo.whatsappPlanExists",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "planInfo.whatsappPlanExists"),
                },
                {
                    group: "planFields",
                    title: "WhatsApp Business Planı Var Mı",
                    key: "planInfo.whatsappBusinessPlanExists",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "planInfo.whatsappBusinessPlanExists"),
                },
                {
                    group: "planFields",
                    title: "Supsis Planı Var Mı",
                    key: "planInfo.supsisPlanExists",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "planInfo.supsisPlanExists"),
                },
                {
                    group: "planFields",
                    title: "Chatbot Planı Var Mı",
                    key: "planInfo.chatbotPlanExists",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "planInfo.chatbotPlanExists"),
                },
                {
                    group: "planFields",
                    title: "Instagram Planı Var Mı",
                    key: "planInfo.instagramPlanExists",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "planInfo.instagramPlanExists"),
                },
                {
                    group: "planFields",
                    title: "Messenger Planı Var Mı",
                    key: "planInfo.messengerPlanExists",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "planInfo.messengerPlanExists"),
                },
                {
                    group: "planFields",
                    title: "Ek Paket Planı Var Mı",
                    key: "planInfo.extraPackagePlanExists",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "planInfo.extraPackagePlanExists"),
                },
                {
                    group: "planFields",
                    title: "Özel Plan Var Mı",
                    key: "planInfo.customPlanExists",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "planInfo.customPlanExists"),
                },
                {
                    group: "planFields",
                    title: "Özellik Planı Var Mı",
                    key: "planInfo.featurePlanExists",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "planInfo.featurePlanExists"),
                },
                // Kullanım Alanları
                {
                    group: "usageFields",
                    title: "Sohbet Sayısı",
                    key: "usage.chatCount",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "usage.chatCount"),
                },
                {
                    group: "usageFields",
                    title: "Destek Talebi Sayısı",
                    key: "usage.ticketCount",
                    renderBodyCell: ({ row }) => this.renderCellContent(row, "usage.ticketCount"),
                },
                {
                    title: "Aksiyonlar",
                    key: "actions",
                    renderBodyCell: ({ row }) => this.renderActionButtons(row),
                },
            ],
            bulkDeleteProgress: 0,
        };
    },
    created() {},
    methods: {
        ...mapActions({
            getSite: "site/getSite",
            delSite: "site/delSite",
            updateSite: "site/updateSite",
        }),
        updateView() {
            request
                .get("sites/refresh-materialized-view")
                .then((response) => {
                    this.$message.success({
                        content: "Site verileri güncellenmeye başladı bu işlem biraz zaman alabilir.",
                        duration: 2,
                        key: "saved",
                    });
                })
                .catch((error) => {
                    console.error("Site verileri güncellenirken hata oluştu:", error);
                    this.$message.error({
                        content: "Site verileri güncellenirken hata oluştu.",
                        duration: 2,
                        key: "saved",
                    });
                });
        },
        handleKeyDown(event) {
            // Alt+R için yenileme
            if ((event.altKey || event.ctrlKey || event.metaKey) && event.key === "r") {
                event.preventDefault();
                this.refreshData();
            }
            // Alt+C için tablo ayarları
            else if ((event.altKey || event.ctrlKey || event.metaKey) && event.key === "c") {
                event.preventDefault();
                this.openColumnSettings();
            }
        },
        refreshData() {
            this.fetch();
        },
        downloadAsExcel() {
            this.fetch(true);
        },
        async fetch(download = false) {
            const filters = this.generateFilterParams();
            const pagination = {
                page: this.paginationCursor.page,
                perPage: this.paginationCursor.perPage,
            };
            this.loading = true;
            this.loadingInstance?.show();

            try {
                const response = await lookupSitesV2(filters, pagination, download);
                if (download) {
                    const { url, success } = response.data;
                    if (success && url) {
                        window.open(url, "_blank");
                    } else {
                        this.$message.error({
                            content: "Excel dosyası oluşturulurken hata oluştu.",
                            duration: 2,
                            key: "saved",
                        });
                    }
                } else {
                    this.sites = response.data.items;
                    this.paginationCursor.total = response.data.total;
                }
            } catch (error) {
                console.error("Site verileri alınırken hata oluştu:", error);
            } finally {
                this.loading = false;
                this.loadingInstance?.close();
            }
        },
        generateFilterParams() {
            const filterParams = this.filters.map((filter) => ({
                key: filter.name,
                value: filter.filterValue,
                operator: filter.operator,
                type: filter.valueType,
            }));
            return filterParams;
        },
        onCursorChanged(newCursor) {
            this.paginationCursor = newCursor;
            this.fetch();
        },
        allColumnsMethod() {
            return this.allColumns;
        },
        columns() {
            const checkboxColumn = {
                type: "checkbox",
                width: 50,
                align: "center",
                key: "checkbox",
                fixed: "left",
                field: "checkbox",
                title: "",
            };

            // Eğer selectedColumns boşsa, tüm sütunları seç
            if (this.selectedColumns.length === 0) {
                return [checkboxColumn, ...this.allColumns];
            }

            // Seçilen sütunlara göre tabloyu güncelle
            const selectedColumns = this.allColumns.filter(
                (column) => this.selectedColumns.includes(column.key) || column.key === 'actions'
            );

            return [checkboxColumn, ...selectedColumns];
        },
        handleSidebarSelection(item) {
            this.$refs.filterToolbar.applyFilterTemplate(item.key);
            this.$router.push({ name: "sites-new", query: { filter: item.key } });
        },
        openColumnSettings() {
            this.isColumnSettingsModalVisible = true;
        },
        closeColumnSettings() {
            this.isColumnSettingsModalVisible = false;
        },
        saveColumnSettings(updatedColumns) {
            this.selectedColumns = updatedColumns;
            // Seçilen sütunları localStorage'a kaydet
            localStorage.setItem("siteListColumns", JSON.stringify(updatedColumns));
            this.closeColumnSettings();
        },
        renderCellContent(row, field) {
            const value = _.get(row, field);
            let component;
            if (value === null || value === undefined || value === "") {
                component = <i class="material-icons empty-cell-icon">remove_circle_outline</i>;
            }
            if (typeof value === "boolean") {
                component = value ? (
                    <span class="chip chip-success">Evet</span>
                ) : (
                    <span class="chip chip-error">Hayır</span>
                );
            }
            return (
                <HoverMenuCell
                    filterAdd={!this.isFilterExists(field)}
                    filterRemove={this.isFilterExists(field)}
                    copy={true}
                    onFilterAdded={() => this.addFilter(field, value)}
                    onFilterRemoved={() => this.removeFilter(field)}
                >
                    {component ? component : value}
                </HoverMenuCell>
            );
        },
        renderDateContent(row, field) {
            const value = _.get(row, field);
            if (value === null || value === undefined || value === "") {
                return <i class="material-icons empty-cell-icon">remove_circle_outline</i>;
            }
            const formattedDate = this.$moment(value).format("DD/MM/YYYY");
            return (
                <HoverMenuCell
                    filterAdd={!this.isFilterExists(field)}
                    filterRemove={this.isFilterExists(field)}
                    copy={true}
                    onFilterAdded={() => this.addFilter(field, value)}
                    onFilterRemoved={() => this.removeFilter(field)}
                >
                    <span class="date-cell">{formattedDate}</span>
                </HoverMenuCell>
            );
        },
        renderEnableChip(row) {
            const value = row.enable;
            const content = value ? (
                <span class="chip chip-success">Aktif</span>
            ) : (
                <span class="chip chip-error">Kapalı</span>
            );

            return (
                <HoverMenuCell
                    filterAdd={!this.isFilterExists("enable")}
                    filterRemove={this.isFilterExists("enable")}
                    onFilterAdded={() => this.addFilter("enable", value)}
                    onFilterRemoved={() => this.removeFilter("enable")}
                >
                    {content}
                </HoverMenuCell>
            );
        },
        renderSuspendChip(row) {
            const value = row.suspend;
            const content = value ? (
                <span class="chip chip-error">Askıya Alındı</span>
            ) : (
                <span class="chip chip-success">Aktif</span>
            );

            return (
                <HoverMenuCell
                    filterAdd={!this.isFilterExists("suspend")}
                    filterRemove={this.isFilterExists("suspend")}
                    onFilterAdded={() => this.addFilter("suspend", value)}
                    onFilterRemoved={() => this.removeFilter("suspend")}
                >
                    {content}
                </HoverMenuCell>
            );
        },
        isFilterExists(filterName) {
            return this.filters.some((filter) => filter.name === filterName);
        },
        addFilter(name, value) {
            const filterMeta = this.$refs.filterToolbar.filterMetas.find((meta) => meta.name === name);
            if (!filterMeta) {
                console.warn(`Filter meta not found for ${name}`);
                return;
            }

            const { operator, valueType } = filterMeta;

            const existingFilterIndex = this.filters.findIndex((filter) => filter.name === name);
            if (existingFilterIndex !== -1) {
                this.filters[existingFilterIndex].filterValue = value;
            } else {
                this.filters.push({
                    ...filterMeta,
                    name,
                    filterValue: value,
                    operator: operator || "equal",
                    valueType: valueType || "string",
                });
            }
        },
        removeFilter(name) {
            this.filters = this.filters.filter((filter) => filter.name !== name);
        },
        renderHoverMenuCell(row, field, value) {
            return (
                <HoverMenuCell
                    filterAdd={!this.isFilterExists(field)}
                    filterRemove={this.isFilterExists(field)}
                    copy={true}
                    onFilterAdded={() => this.addFilter(field, value)}
                    onFilterRemoved={() => this.removeFilter(field)}
                >
                    {value}
                </HoverMenuCell>
            );
        },
        resetFilters() {
            this.filters = [];
        },
        renderActionButtons(row) {
            return (
                <div class="d-flex w-100 justify-content-start">
                    <a-button
                        class="actionButton d-flex align-items-center px-1"
                        v:on-click={() => this.editSite(row._id)}
                    >
                        <ActionEdit />
                    </a-button>
                    <a-button
                        class="actionButton d-flex align-items-center px-1"
                        v:on-click={() => this.deleteSite(row)}
                    >
                        <ActionDelete />
                    </a-button>
                </div>
            );
        },
        editSite(id) {
            console.log("Düzenle:", id);
        },
        deleteSite(item) {
            this.$dialog
                .confirm(this.$t("message.deleteSite", { siteName: _.get(item, "siteAddress") }), {
                    okText: this.$t("message.yes"),
                    cancelText: this.$t("message.no"),
                })
                .then(() => {
                    // Silme işlemi için gerekli kodu buraya ekleyin
                    console.log("Sil:", item._id);
                });
        },
        onSelectRow(row) {
            const selectedRowKeys = this.checkboxOption.selectedRowKeys;
            const index = selectedRowKeys.indexOf(row._id);
            if (index > -1) {
                selectedRowKeys.splice(index, 1);
            } else {
                selectedRowKeys.push(row._id);
            }
        },
        async bulkDelete() {
            const selectedRows = this.checkboxOption.selectedRowKeys;
            const confirmed = await this.$dialog.confirm('Seçilen siteleri silmek istediğinize emin misiniz?');
            if (confirmed) {
                const deletePromises = selectedRows.map((rowId, index) => {
                    return this.delSite(rowId).then(() => {
                        this.bulkDeleteProgress = Math.round(((index + 1) / selectedRows.length) * 100);
                        this.sites.data = this.sites.data.filter((site) => !selectedRows.includes(site._id));
                        this.sites.count -= 1;
                        this.sites.total -= 1;
                    });
                });
                await Promise.all(deletePromises);
                this.checkboxOption.selectedRowKeys = [];
                this.bulkDeleteProgress = 0;
                this.get();
            }
        },
        async del(item) {
            const confirmed = await this.$dialog.confirm(this.$t("message.deleteSite", { siteName: _.get(item, "clientAddress") }));
            if (confirmed) {
                await this.delSite(item._id);
                this.sites.data = this.sites.data.filter((site) => site._id !== item._id);
                this.sites.count -= 1;
                this.sites.total -= 1;
                sendSocketMessage("admin site-delete", { siteId: item._id });
            }
        },
    },
    mounted() {
        this.loadingInstance = VeLoading({
            target: document.querySelector("#refresh-materialized-view"),
            name: "wave",
        });
        this.$refs.filterToolbar?.applyFilterTemplate(this.defaultFilterTemplate);

        // Seçilen sütunları localStorage'dan yükle
        const savedColumns = localStorage.getItem("siteListColumns");
        if (savedColumns) {
            this.selectedColumns = JSON.parse(savedColumns);
        } else {
            this.selectedColumns = this.allColumns.map((x) => x.key);
        }

        // Klavye kısayollarını ekle
        document.addEventListener("keydown", this.handleKeyDown);
    },

    beforeDestroy() {
        // Bileşen yok edilmeden önce olay dinleyiciyi kaldır
        document.removeEventListener("keydown", this.handleKeyDown);
    },

    watch: {
        filters: {
            handler() {
                this.paginationCursor.page = 1;
                this.fetch();
            },
            deep: true,
        },
        defaultFilterTemplate: {
            handler(newTemplate) {
                this.$refs.filterToolbar?.applyFilterTemplate(newTemplate);
            },
            immediate: true,
        },
    },
});
</script>

<style lang="scss" scoped>
#site-list-component {
    display: flex;
    flex-direction: column;
    height: 100vh;

    .route-page-content {
        display: flex;
        flex: 1;
    }

    .toolbar-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;

        .actions {
            display: flex;
            gap: 5px;

            .supsis-button {
                max-width: unset;
                width: max-content;
            }
        }

        .keyboard-shortcut {
            margin-right: 3px;

            font-size: 0.8rem;
            font-weight: bold;
            color: #000;
            background-color: #f1f1f1;
            padding: 2px 5px;
            border-radius: 5px;
            border: 1px solid #ccc;
            width: max-content;
            height: 19px;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
        }
    }

    .table-wrapper {
        width: 90vw;
        max-width: 90vw;
        overflow-y: hidden;
        overflow-x: auto;
    }

    .position-relative {
        flex: 1;
        width: 100%;
        padding-top: 20px;
    }

    .siteListSettingContainer {
        display: flex;
        justify-content: left;
        width: 40%;
        position: absolute;
        margin-top: 2px;
        z-index: 50;

        div {
            margin-right: 10px;
        }
    }

    .content-wrapper {
        padding: 0 30px;
    }
}

.table-placeholder {
    text-align: center;
    padding: 20px;
    color: #999;
}

.chip {
    display: inline-block;
    padding: 4px 8px;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;

    &.chip-success {
        background-color: #4caf50;
        color: white;
    }

    &.chip-error {
        background-color: #f44336;
        color: white;
    }

    &.chip-warning {
        background-color: #ff9800;
        color: white;
    }
}

.actionButton {
    padding: 0 5px;
    margin-right: 5px;

    &:hover {
        background-color: #f0f0f0;
    }
}

.date-cell {
    color: #2196f3;
    font-weight: 500;
}

.empty-cell-icon {
    color: #bfbfbf;
    font-size: 18px;
    vertical-align: middle;
}

.hover-menu-cell {
    cursor: pointer;
}

.bulk-action-bar {
    margin-bottom: 16px;
}

.progress-bar {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 300px;
}
</style>

<style>
#site-list-column-settings {
    .ant-modal {
        width: 1200px !important;
    }
}
</style>
